/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The Shop model module.
 * @module model/Shop
 * @version 1.0.0
 */
class Shop {
    /**
     * Constructs a new <code>Shop</code>.
     * Student shop data
     * @alias module:model/Shop
     */
    constructor() { 
        
        Shop.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>Shop</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Shop} obj Optional instance to populate.
     * @return {module:model/Shop} The populated <code>Shop</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Shop();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
Shop.prototype['id'] = undefined;

/**
 * @member {String} name
 */
Shop.prototype['name'] = undefined;






export default Shop;

